import React, { useState, useEffect, useRef } from "react";
import styles from "./Withdraw.module.scss";
import QrReader from 'react-web-qr-reader';
import {
  authRequest,
  authRequestNb,
  refreshToken,
  decodeUserToken
} from "../../../Helper/helper";
import swal from "sweetalert";
import { AiOutlineClose } from "react-icons/ai";
import { BiQrScan } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
const COOLDOWN_MS = 120_000;                     // 2 minutes
const COOLDOWN_KEY = "withdraw_otp_cooldown";    // single key for withdraw OTP cooldown
const COOLDOWN_MOBILE_MS = 120_000;                     // 2 minutes
const COOLDOWN_MOBILE_KEY = "withdraw_otp_mobile_cooldown";    // single key for withdraw mobile OTP cooldown

const Withdraw = ({ dmode , setWtstatus, coin, availableBalance , globalRes }) => {
  const [data, setData] = useState();
  const [chain, setChain] = useState();
  const [formData, setFormData] = useState({ amount: "" , destination : "" });
  const [QrRead, setQrRead] = useState(false);
  const [errormessage, setErrormessage] = useState({});
  const [feeInfo, setFeeInfo] = useState({});
  const [feeBoxV, setFeeBoxV] = useState(false);
  const [_otptext, set_otptext] = useState("Send OTP");
  const [_otpMobiletext, set_otpMobiletext] = useState("Send Mobile OTP");
  const [impNote, setImpNote] = useState([]);
  const [isIndian, setIsIndian] = useState(false);
  const [_subtext, set_subtext] = useState(`Withdraw ${coin}`);
  const navigate = useNavigate()
  

  // label (_otptext) already exists; add:
  const [cooldownLeft, setCooldownLeft] = useState(0);
  const [canResend, setCanResend] = useState(true);
  const [cooldownMobileLeft, setCooldownMobileLeft] = useState(0);
  const [canMobileResend, setCanMobileResend] = useState(true);
  const tickRef = useRef(null);
  const tickMobileRef = useRef(null);

  const [isInternalTransfer, setIsInternalTransfer] = useState(false);
  const [checkingInternal, setCheckingInternal] = useState(false);
  const internalDebounceRef = useRef(null);

  useEffect(()=>{
    const udata=decodeUserToken(sessionStorage.getItem("user"));
    if(udata && udata?.country){
      setIsIndian(udata.country==="India"?true:false);
    }
    // console.log("udata => ",udata);
  },[])
  // helper: mm:ss
  const fmt = (s) => {
    const m = Math.floor(s / 60).toString().padStart(2, "0");
    const ss = Math.floor(s % 60).toString().padStart(2, "0");
    return `${m}:${ss}`;
  };
  const getDestinationTagForCheck = () => {
    // API expects destination_tag (int). For non-XRP it can be 0.
    if (coin === "XRP") {
      const v = formData.destination ?? "";
      const n = parseInt(v, 10);
      return Number.isFinite(n) ? n : 0;
    }
    return 0;
  };
 // Option-B override:
  // If internal transfer AND transfer_status=1, allow withdraw even if activeStatus=0.
  const allowInternalOverride = () => {
    return isInternalTransfer && String(feeInfo?.transfer_status) === "1";
  };
  // ✅ NEW: pick min/max based on internal transfer
  const currentMinAmount = () => {
    const v = isInternalTransfer ? feeInfo?.transfer_min_amount : feeInfo?.min_amount;
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  };

  const currentMaxAmountRaw = () => {
    // "N/L" means no limit
    return isInternalTransfer ? feeInfo?.transfer_max_amount : feeInfo?.max_amount;
  };

  const currentMaxAmount = () => {
    const raw = currentMaxAmountRaw();
    if (raw === "N/L" || raw === "N/A" || raw === undefined || raw === null || raw === "") return null;
    const n = parseFloat(raw);
    return Number.isFinite(n) ? n : null;
  };
  const isOutOfServiceCrypto = () => {
    // for non-INR: out of service if activeStatus=0 AND no internal override
    return String(feeInfo?.activeStatus) === "0" && !allowInternalOverride();
  };
  const effectiveFee = () => {
    const f = parseFloat(feeInfo?.fee || 0) || 0;
    const tf = parseFloat(feeInfo?.transfer_fee || 0) || 0;
    return isInternalTransfer ? tf : f;
  };
  // ⬇️ Resume cooldown on mount
  useEffect(() => {
    const endAtStr = localStorage.getItem(COOLDOWN_KEY);
    const endAt = endAtStr ? parseInt(endAtStr, 10) : 0;
    const now = Date.now();
    const msLeft = Math.max(0, endAt - now);

    if (msLeft > 0) {
      setCanResend(false);
      setCooldownLeft(Math.ceil(msLeft / 1000));
      set_otptext(`Resend in ${fmt(Math.ceil(msLeft / 1000))}`);

      clearInterval(tickRef.current);
      tickRef.current = setInterval(() => {
        const remaining = Math.max(0, endAt - Date.now());
        const sec = Math.ceil(remaining / 1000);
        setCooldownLeft(sec);
        set_otptext(sec > 0 ? `Resend in ${fmt(sec)}` : "Click here to send OTP");
        if (remaining <= 0) {
          clearInterval(tickRef.current);
          setCanResend(true);
        }
      }, 1000);
    } else {
      setCanResend(true);
      set_otptext("Click here to send OTP");
    }

    return () => clearInterval(tickRef.current);
  }, []);
  // ⬇️ Resume cooldown on mount
  useEffect(() => {
    const endAtStr = localStorage.getItem(COOLDOWN_KEY);
    const endAt = endAtStr ? parseInt(endAtStr, 10) : 0;
    const now = Date.now();
    const msLeft = Math.max(0, endAt - now);

    if (msLeft > 0) {
      setCanMobileResend(false);
      setCooldownMobileLeft(Math.ceil(msLeft / 1000));
      set_otpMobiletext(`Resend in ${fmt(Math.ceil(msLeft / 1000))}`);

      clearInterval(tickMobileRef.current);
      tickMobileRef.current = setInterval(() => {
        const remaining = Math.max(0, endAt - Date.now());
        const sec = Math.ceil(remaining / 1000);
        setCooldownMobileLeft(sec);
        set_otpMobiletext(sec > 0 ? `Resend in ${fmt(sec)}` : "Click here to send OTP");
        if (remaining <= 0) {
          clearInterval(tickMobileRef.current);
          setCanMobileResend(true);
        }
      }, 1000);
    } else {
      setCanMobileResend(true);
      set_otpMobiletext("Click here to send OTP");
    }

    return () => clearInterval(tickMobileRef.current);
  }, []);

  const chainChange = async (e) => {
    setChain(e.target.value);
    formDataHandler("blockchain", e.target.value);
  };

  const formDataHandler = (key, value) => {
    let change = formData;
    //console.log("_value",value);
    if( parseFloat(value) >0){
      change[key] = value;
      errorHandler(key,"")
      if (key === "amount" && value ) {
        change[key] = value
        const _value = parseFloat(value);
        if(_value>0){
  
          const _avbal = parseFloat(availableBalance);
          // ✅ use internal min/max when internal transfer
          const min = currentMinAmount();
          const max = currentMaxAmount(); // null means no limit

          // Clamp to available balance and max
          let finalAmount = _value;

          // (optional) do NOT force min here; only validate on submit
          // if (min > 0 && finalAmount < min) finalAmount = min;

          if (max !== null && max <= _avbal) {
            finalAmount = finalAmount > max ? max : finalAmount;
          } else {
            finalAmount = finalAmount > _avbal ? _avbal : finalAmount;
            if (max !== null) {
              finalAmount = finalAmount > max ? max : finalAmount;
            }
          }

          change[key] = finalAmount;
          const ef = effectiveFee();
          // console.log("ef",ef);
          formDataHandler("total", value - ef);
          formDataHandler("fee", ef);

          // const max = feeInfo.max_amount === "N/L" ? false : parseFloat(feeInfo.max_amount);
          // if (max && max <= _avbal) {
          //   change[key] = _value > max ? max : _value;
          // } else {
          //   change[key] = _value > _avbal ? _avbal : _value;
          // }
          // formDataHandler("total", value - feeInfo.fee);
          // formDataHandler("fee", feeInfo.fee);
        
        }
      }

    }
    else
    {
      change[key] = value;
    }
    errorHandler(key, "");
    //console.log("key=>",key);
   // console.log("value=>",value);
    //console.log("change=>",change);
    setFormData({ ...change });
  };
  const checkInternalTransfer = async () => {
    // Only for non-INR
    if (coin === "INR") return;

    const addr = (formData.address || "").trim();
    if (!addr) {
      setIsInternalTransfer(false);
      return;
    }

    const destination_tag = getDestinationTagForCheck();

    setCheckingInternal(true);
    try {
      const res = await authRequest({ address: addr, destination_tag }, "internal-transfer-status");
      refreshToken(res.refresh_token);

      if (res.status === 200 && res.data === true) {
        setIsInternalTransfer(true);
      } else {
        setIsInternalTransfer(false);
      }
    } catch (e) {
      setIsInternalTransfer(false);
    } finally {
      setCheckingInternal(false);
    }
  };
  useEffect(() => {
    if (coin === "INR") return;

    clearTimeout(internalDebounceRef.current);
    internalDebounceRef.current = setTimeout(() => {
      checkInternalTransfer();
    }, 600);

    return () => clearTimeout(internalDebounceRef.current);
  }, [formData.address, formData.destination, coin]);
  // Recalculate fee/total if internal status changes while amount already filled
  // useEffect(() => {
  //   if (coin === "INR") return;
  //   if (!formData.amount) return;

  //   const ef = effectiveFee();
  //   const amt = parseFloat(formData.amount || 0) || 0;

  //   // update computed fields (keeps your structure)
  //   formDataHandler("fee", ef);
  //   formDataHandler("total", amt - ef);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [isInternalTransfer]);
  useEffect(() => {
    if (coin === "INR") return;
    if (!formData.amount) return;

    const ef = effectiveFee();
    const amt = parseFloat(formData.amount || 0) || 0;

    // If the amount violates new max (switching internal/external), clamp it once
    const max = currentMaxAmount();
    let adjusted = amt;
    if (max !== null && adjusted > max) adjusted = max;

    const av = parseFloat(availableBalance) || 0;
    if (adjusted > av) adjusted = av;

    // Update without recursion loops
    setFormData((prev) => ({
      ...prev,
      amount: adjusted,
      fee: ef,
      total: adjusted - ef,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInternalTransfer]);
  const validateAmountByLimits = () => {
    const amt = parseFloat(formData.amount || 0) || 0;
    const min = currentMinAmount();
    const max = currentMaxAmount(); // null => no limit

    if (min > 0 && amt < min) {
      errorHandler("amount", `Minimum amount is ${min}`);
      swal(`Minimum amount is ${min}`);
      return false;
    }

    if (max !== null && amt > max) {
      errorHandler("amount", `Maximum amount is ${max}`);
      swal(`Maximum amount is ${max}`);
      return false;
    }

    return true;
  };
  const errorHandler = (key, value) => {
    let change = errormessage;
    change[key] = value;
    setErrormessage({ ...change });
  };

  const sumbitHandler = async (e) => {
    e.preventDefault();
    set_subtext("Please Wait . . .");
    if(isIndian){
      if(!formData.mobileotp){
        errorHandler("mobileotp","Please enter OTP !")
        !formData.amount && errorHandler("amount","Please enter Amount !")
        !formData.otp && errorHandler("otp","Please enter OTP !")
        set_subtext(`Withdraw ${coin}`);
        return;
      }
    }
    if(coin === 'INR'){
      if(formData.amount && formData.otp ){
        const res = await authRequest({
          amount : formData.amount,
          currency : coin,
          otp : formData.otp,
          mobileotp : formData.mobileotp,
        } , "submit-withdraw");
        refreshToken(res.refresh_token)

        if(res.status === 200){
           swal(res.message)
           setWtstatus(false)
        }else if(res.status === 401){
          for (const keys of Object.keys(res.data)) {
            errorHandler(keys,res.data[keys])
          }
        }else{
          swal(res.message)
          if(res.refresh_token === false){
            navigate("/signin")
          }
        }
      }else{
        !formData.amount && errorHandler("amount","Please enter Amount !")
        !formData.otp && errorHandler("otp","Please enter OTP !")
      }
    }else{

      //  const validAddress = WAValidator.validate("0x5E33298a693e4CF1E05f179bFebd4d414f6A5340", 'BTC');
     // console.log("formData =>",formData)

      // Option-B override implemented here:
      // Out of service if activeStatus=0 AND not allowed internal override
      if (isOutOfServiceCrypto()) {
        swal("Withdraw is currently out of service for this coin/network.");
        set_subtext(`Withdraw ${coin}`);
        return;
      }

      // If internal transfer but transfer_status is not 1, block
      if (isInternalTransfer && String(feeInfo?.transfer_status) !== "1") {
        swal("Internal transfer is currently disabled for this coin/network.");
        set_subtext(`Withdraw ${coin}`);
        return;
      }
      if (!validateAmountByLimits()) {
        set_subtext(`Withdraw ${coin}`);
        return;
      }
      if(parseFloat(formData.total)<=0){
        // swal("Total must be greater than 0.");
        errorHandler("total","Total must be greater than 0.")
        set_subtext(`Withdraw ${coin}`);
        return;
      }
      if(formData.amount && formData.otp && formData.address && formData.blockchain){
        const res = await authRequest({
          amount : formData.amount,
          address : formData.address,
          blockchain : formData.blockchain,
          destination_tag : formData.destination,
          currency : coin,
          otp : formData.otp,
          mobileotp : formData.mobileotp,
        } , "submit-withdraw");
        refreshToken(res.refresh_token)
        if(res.status === 200){
          swal(res.message)
          setWtstatus(false)
        }else if(res.status === 401){
          for (const keys of Object.keys(res.data)) {
            errorHandler(keys,res.data[keys])
          }
        }else{
          swal(res.message)
          if(res.refresh_token === false){
            navigate("/signin")
          }
        }
      }else{
        !formData.amount && errorHandler("amount","Please enter Amount !")
        !formData.address && errorHandler("address","Please enter Address !")
        !formData.otp && errorHandler("otp","Please enter OTP !")
      }
    }
    set_subtext(`Withdraw ${coin}`);
  };

  const sendOtpRequest = async () => {
    if (!canResend) {
      swal(`Please wait ${fmt(cooldownLeft)} before resending OTP.`);
      return;
    }
    set_otptext("Otp Sending . . .");
    const res = await authRequestNb("withdraw-otp");
    if(res.status === 200){
      // start cooldown
    const endAt = Date.now() + COOLDOWN_MS;
    localStorage.setItem(COOLDOWN_KEY, String(endAt));
    setCanResend(false);

    clearInterval(tickRef.current);
    tickRef.current = setInterval(() => {
      const remaining = Math.max(0, endAt - Date.now());
      const sec = Math.ceil(remaining / 1000);
      setCooldownLeft(sec);
      set_otptext(sec > 0 ? `Resend in ${fmt(sec)}` : "Click here to send OTP");
      if (remaining <= 0) {
        clearInterval(tickRef.current);
        setCanResend(true);
      }
    }, 1000);
      // set_otptext("Click here to send OTP");  
    }
    refreshToken(res.refresh_token)
    swal(res.message);
  };
  const sendMobileOtpRequest = async () => {
    if(!isIndian){
      swal(`Only user from indian origin can send mobile otp.`);
      return;
    }
    if (!canMobileResend) {
      swal(`Please wait ${fmt(cooldownMobileLeft)} before resending OTP.`);
      return;
    }
    set_otpMobiletext("Otp Sending . . .");
    const res = await authRequestNb("withdraw-mobile-otp");
    if(res.status === 200){
      // start cooldown
      //       COOLDOWN_MOBILE_MS
      // COOLDOWN_MOBILE_KEY
      const endAt = Date.now() + COOLDOWN_MOBILE_MS;
      localStorage.setItem(COOLDOWN_MOBILE_KEY, String(endAt));
      setCanMobileResend(false);

      clearInterval(tickMobileRef.current);
      tickMobileRef.current = setInterval(() => {
        const remaining = Math.max(0, endAt - Date.now());
        const sec = Math.ceil(remaining / 1000);
        setCooldownMobileLeft(sec);
        set_otpMobiletext(sec > 0 ? `Resend in ${fmt(sec)}` : "Click here to send mobile OTP");
        if (remaining <= 0) {
          clearInterval(tickMobileRef.current);
          setCanMobileResend(true);
        }
      }, 1000);
    }else{
      set_otptext("Click here to send mobile OTP");  

    }
    refreshToken(res.refresh_token)
    swal(res.message);
  };

  useEffect(() => {
    (async () => {
      setFeeBoxV(false);
      setFormData({amount: ""})
      setErrormessage({})
      setQrRead(false)
      
      const res = await authRequest({ currency: coin }, "get-withdraw-fees");
      setData(res);
      setImpNote(res.importantNoteArray);
      setChain(res.data[0].blockchain_type);
      setFormData({blockchain : res.data[0].blockchain_type , amount: ""});
      refreshToken(res.refresh_token);
    })();
  }, [coin]);

  useEffect(() => {
    // console.log("data",data);
    data?.data.map((value) => {
      // console.log("value",value);
      if (value.blockchain_type === chain) {
        setFeeInfo(value);
      }
    });
    setFormData({amount: ""})
    formDataHandler("blockchain", chain);
    setFeeBoxV(false);
    setErrormessage({})
    setQrRead(false)
  }, [chain]);

  return coin === "INR" ? (
    <div className={dmode ? styles.withdraw_d : styles.withdraw_l}>
        <h4 className="text-center mt-0">
          {/* {impNote} */}
          <ol>
          {impNote?.map((note, i) => (
            <>
            <li key={i}>{note}</li>

            </>
            
          ))}
          </ol>

        </h4>
      <form className='inputHandle' onSubmit={sumbitHandler}>
        <div className={`${styles.row} flex-between withIcon`}>
          <h3 className='borderRight0'>{coin}</h3>
          
          <input
            type="number"
            name="amount"
            step="any"
            min={0}
            placeholder="Amount"
            value={formData.amount}
            onChange={(e) => formDataHandler("amount", e.target.value)}
          />
          {/* <button className='send-otp-button1'
            type="button"
            onClick={() => {
              formDataHandler(
                "amount",
                (feeInfo.max_amount === "N/L" ||
                  parseFloat(feeInfo.max_amount) >= parseFloat(availableBalance)) && globalRes?.data?.lock_inr < parseFloat(availableBalance)
                  ? parseFloat(availableBalance)
                  : parseFloat(feeInfo.max_amount) <
                      parseFloat(availableBalance)  ?
                      parseFloat(feeInfo.max_amount) : 0
              );
            }}
          >
            All
          </button> */}
          <button className='send-otp-button1'
            type="button"
            onClick={() => {
              formDataHandler(
                "amount",
                (feeInfo.max_amount === "N/L" ||
                  parseFloat(feeInfo.max_amount) >= parseFloat(availableBalance))
                  ? parseFloat(availableBalance)
                  : parseFloat(feeInfo.max_amount) <
                      parseFloat(availableBalance)  ?
                      parseFloat(feeInfo.max_amount) : 0
              );
            }}
          >
            All
          </button>
          <button type="button"  className='send-otp-button2' onClick={() => setFeeBoxV(true)}>
            Fees
          </button>
        </div>

        {feeBoxV && (
          <div className={`${styles.wfi} flex-center column widthFeesPopup `}>
            <h2 className="flex-between">
              <span>Withdraw Fees</span>{" "}
              <span onClick={() => setFeeBoxV(false)} className="flex-center">
                <AiOutlineClose />
              </span>
            </h2>
            <div style={{ width: "100%" }} className="flex-start column widthpad">
              <div className={styles.wfi_row}>
                From : <span>{feeInfo.min_amount}</span>
              </div>
              <div className={styles.wfi_row}>
                To : <span>{feeInfo.max_amount}</span>
              </div>
              
              <div className={styles.wfi_row}>
                Fee : <span>{feeInfo.fee}</span>
              </div>
              <div className={styles.wfi_row}>
                Internal Transfer From : <span>{feeInfo.transfer_min_amount}</span>
              </div>
              <div className={styles.wfi_row}>
                Internal Transfer To : <span>{feeInfo.transfer_max_amount}</span>
              </div>
              
              <div className={styles.wfi_row}>
                Internal Transfer Fee : <span>{feeInfo.transfer_fee}</span>
              </div>
            </div>
          </div>
        )}

        {errormessage.amount && (
          <p className={styles.warning_note}>{errormessage.amount}</p>
        )}
        <div className={`${styles.row} flex-between`}>
          <h3 className='borderRight0'>Fees</h3>
          <input
            type="number"
            name="fees"
            readOnly={true}
            value={formData.amount && effectiveFee()}
            min={0}
            placeholder="0.000000"
          />
          <h3>{coin}</h3>
        </div>
        <div className={`${styles.row} flex-between`}>
          <h3 className='borderRight0'>Total</h3>
          <input
            type="number"
            name="total"
            value={formData.amount && formData.amount - effectiveFee()}
            readOnly={true}
            min={0}
            placeholder="0.000000"
          />
          <h3>{coin}</h3>
        </div>

        <div className={`${styles.row} flex-between withIcon`}>
          <input
            type="text"
            name="otp"
            placeholder="Enter OTP"
            onChange={(e) => formDataHandler("otp", e.target.value)}
          />
          <button className='send-otp-button2'
            type="button"
            onClick={sendOtpRequest}
            disabled={!canResend} 
          >
            {/* {"Click here to send OTP"} */}
            {_otptext}
          </button>
        </div>
        {errormessage.otp && (
          <p className={styles.warning_note}>{errormessage.otp}</p>
        )}
        {isIndian && (
          <>
        
            <div className={`${[styles.row , styles.otp].join(" ")} flex-between withIcon`}>
              <input
                type="text"
                name="mobileotp"
                placeholder="Enter Mobile OTP"
                onChange={(e) => formDataHandler("mobileotp", e.target.value)}
              />
              <button
              className='send-otp-button2 '
                type="button"
                onClick={sendMobileOtpRequest}
                
              >
                {_otpMobiletext}
              </button>
            </div>
            {errormessage.mobileotp && (
              <p className={styles.warning_note}>{errormessage.mobileotp}</p>
            )}
        </>
        )}
        {/* <button disabled={parseFloat(availableBalance) < globalRes?.data?.lock_inr} style={{opacity : parseFloat(availableBalance) < globalRes?.data?.lock_inr ? "0.5" : "1"}} type="submit">
         
          _subtext
        </button> */}
          {/* Withdraw {coin} */}
       {/*  <button disabled={feeInfo.activeStatus==="0" ? true : (parseFloat(availableBalance) < globalRes?.data?.lock_inr)} style={{opacity : parseFloat(availableBalance) < globalRes?.data?.lock_inr ? "0.5" : "1"}} type="submit">
          {feeInfo.activeStatus==="1" ? _subtext  : "Out of Service !"}
        </button> */}
          {/* Withdraw {coin} */}
         {/* <button disabled={feeInfo.activeStatus==="0" ? true : false} style={{opacity : feeInfo.activeStatus==="0" ? "0.5" : "1"}} type="submit">
          {feeInfo.activeStatus==="1" ? _subtext  : "Out of Service !"}
        </button> */}
        <button disabled={isOutOfServiceCrypto()} style={{ opacity: isOutOfServiceCrypto() ? 0.6 : 1 }} type="submit">
          {isOutOfServiceCrypto() ? "Out of Service !" : _subtext}
        </button>
        { globalRes?.data?.lock_inr>0
        ?
        <div className={`${styles.row} flex-between1`}>
        <h6>Important Note</h6>
        <p>Minimum wallet balance is {globalRes?.data?.lock_inr}  INR.</p>
      </div> 
        :
        <></>
        }
        {/*}
         <div className={`${styles.row} flex-between1`}>
              <h6>Important Note</h6>
              <p>Minimum wallet balance is {globalRes?.data?.lock_inr}  INR.</p>
            </div> */ }
      </form>
    </div>
  ) : (
    <div className={styles.withdraw_l}>
      <div className="slectblockchian">
      {data && (
        <div className={` ${styles.dbox} borderfullforget`}>
          <select
            onChange={chainChange}
            value={chain}
            className={styles.chainOpt}
          >
            {data.data?.map((value, i) => (
              <option key={i} value={value.blockchain_type}>
                {value.blockchain_type.toUpperCase()}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>

      <form onSubmit={sumbitHandler} className='inputHandle'>
        <div className={`${styles._address} flex-between`}>
        <input
          onChange={(e) => formDataHandler("address", e.target.value)}
          defaultValue={formData.address && formData.address}
          type="text"
          name="address"
          placeholder={`${coin} Address`}
        />
        <span onClick={() => QrRead ? setQrRead(false) : setQrRead(true)} className="flex-center">{!QrRead ? <BiQrScan /> : <AiOutlineClose />}</span>
        </div>
        {QrRead && <QrReader
        onScan={(result) => {
          if (!!result) {
            formDataHandler("address",result.data)
            setQrRead(false)
          }
        }}
        onError={(error)=>{
          if (!!error) {
            window.alert(error);
            setQrRead(false);
          }
        }}
        className={styles.qrReader}
      />}
        {errormessage.address && (
          <p className={styles.warning_note}>{errormessage.address}</p>
        )}
        {coin === "XRP" && <div className={`${styles.row} flex-between`}>
        <input
            name="destination"
            step="any"
            placeholder="Destination"
            value={formData.destination}
            onChange={(e) => formDataHandler("destination", e.target.value)}
          />
        </div>}
        <div className={`${styles.row} flex-between withIcon`}>
          <h3 className='borderRight0'>{coin}</h3>
          <input
            type="number"
            name="amount"
            step="any"
            min={0}
            placeholder="Amount"
            value={formData.amount}
            onChange={(e) => formDataHandler("amount", e.target.value)}
          />
          <button
            className="send-otp-button1" 
            type="button"
            onClick={() => {
              formDataHandler("amount",parseFloat(availableBalance))
              // formDataHandler(
              //   "amount",
              //   feeInfo.max_amount === "N/L" ||
              //     parseFloat(feeInfo.max_amount) >= parseFloat(availableBalance)
              //     ? parseFloat(availableBalance)
              //     : parseFloat(feeInfo.max_amount) <
              //         parseFloat(availableBalance) &&
              //         parseFloat(feeInfo.max_amount)
              // );
            }}
          >
            All
          </button>
          <button className="send-otp-button2" type="button" onClick={() => setFeeBoxV(true)}>
            Fees
          </button>
        </div>

        {feeBoxV && (
          <div className={`widthFeesPopup ${styles.wfi} flex-center column `}>
            <h2 className="flex-between">
              <span>Withdraw Fees</span>{" "}
              <span onClick={() => setFeeBoxV(false)} className="flex-center">
                <AiOutlineClose />
              </span>
            </h2>
            <div style={{ width: "100%" }} className="flex-start column widthpad">
              <div className={styles.wfi_row}>
                From : <span>{feeInfo.min_amount}</span>
              </div>
              <div className={styles.wfi_row}>
                To : <span>{feeInfo.max_amount}</span>
              </div>
              <div className={styles.wfi_row}>
                Fee : <span>{feeInfo.fee}</span>
              </div>
              <div className={styles.wfi_row}>
                Internal Transfer From : <span>{feeInfo.transfer_min_amount}</span>
              </div>
              <div className={styles.wfi_row}>
                Internal Transfer To : <span>{feeInfo.transfer_max_amount}</span>
              </div>
              <div className={styles.wfi_row}>
                Internal Transfer Fee : <span>{feeInfo.transfer_fee}</span>
              </div>
            </div>
          </div>
        )}

        {errormessage.amount && (
          <p className={styles.warning_note}>{errormessage.amount}</p>
        )}
        <div className={`${styles.row} flex-between`}>
          <h3 className='borderRight0'>Fees</h3>
          <input
            type="number"
            name="fees"
            readOnly={true}
            value={formData.amount && effectiveFee()}
            min={0}
            placeholder="0.000000"
          />
          <h3>{coin}</h3>
        </div>
        <div className={`${styles.row} flex-between`}>
          <h3 className='borderRight0'>Total</h3>
          <input
            type="number"
            name="total"
            value={formData.amount && formData.amount - effectiveFee()}
            readOnly={true}
            min={0}
            placeholder="0.000000"
          />
          <h3>{coin}</h3>
        </div>

        <div className={`${[styles.row , styles.otp].join(" ")} flex-between withIcon`}>
          <input
            type="text"
            name="otp"
            placeholder="Enter OTP"
            onChange={(e) => formDataHandler("otp", e.target.value)}
          />
          <button
          className='send-otp-button2 '
            type="button"
            onClick={sendOtpRequest}
            
          >
            {/* {"Click here to send OTP"} */}
            {_otptext}
          </button>
        </div>
        {errormessage.otp && (
          <p className={styles.warning_note}>{errormessage.otp}</p>
        )}
        {isIndian && (
          <>
        
            <div className={`${[styles.row , styles.otp].join(" ")} flex-between withIcon`}>
              <input
                type="text"
                name="mobileotp"
                placeholder="Enter Mobile OTP"
                onChange={(e) => formDataHandler("mobileotp", e.target.value)}
              />
              <button
              className='send-otp-button2 '
                type="button"
                onClick={sendMobileOtpRequest}
                
              >
                {_otpMobiletext}
              </button>
            </div>
            {errormessage.mobileotp && (
              <p className={styles.warning_note}>{errormessage.mobileotp}</p>
            )}
        </>
        )}
        {/* `Withdraw ${coin}` */}
     
        {/* <button disabled={feeInfo.activeStatus==="0" ? true : false} style={{opacity : feeInfo.activeStatus==="0" ? 0.7 : 1}} type="submit">{feeInfo.activeStatus==="1" ? _subtext  : "Out of Service !"}</button> */}
         {/* Button uses Option-B override */}
         <button disabled={isOutOfServiceCrypto()} style={{ opacity: isOutOfServiceCrypto() ? 0.6 : 1 }} type="submit">
          {isOutOfServiceCrypto() ? "Out of Service !" : _subtext}
        </button>
       
      </form>
    </div>
  );
};

export default Withdraw;
